module.exports = __webpack_public_path__ + "static/img/training_system_s5_max.e33e1225.png";